<template>
  <div
    class="img-fluid"
    :class="$store.state.mobile ? '' : 'pt-3'"
  >
    <template v-if="loading">
      <div :class="$store.state.mobile ? 'pt-3' : 'ps-3'">
        <v-skeleton-loader
          class="fill-height"
          type="image"
          tile
          height="450"
        />
      </div>
      <v-skeleton-loader
        type="article"
        tile
      />
    </template>
    <div
      v-else
    >
      <v-row
        v-if="$store.state.mobile"
        class="px-2 py-3 mb-4 grey lighten-5"
      >
        <v-icon
          size="18"
          color="primary"
        >
          mdi-home
        </v-icon>
        <v-breadcrumbs
          :items="breadcrumbs"
          class="ps-1 py-0"
        />
      </v-row>
      <div
        :class="$store.state.mobile ? '' : 'ps-3'"
        v-html="$store.getters.languageGetter === '1' ? info.content : info.contentEn"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'InformationContent',
  props: {
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      info: {},
      breadcrumbs: [],
    };
  },
  watch: {
    $route() {
      this.loadPageData();
    },
  },
  created() {
    this.loadPageData();
  },
  methods: {
    ...mapActions('information', ['getInfoDetailAsync']),
    loadPageData() {
      this.loading = true;
      this.getInfoDetailAsync({ id: this.id }).then((res) => {
        this.info = res;
        this.breadcrumbs = [{
          text: this.$store.getters.languageGetter === '1' ? 'الصفحة الرئيسية' : 'Home',
          disabled: false,
          to: '/',
        },
        {
          text: this.title,
          disabled: false,
        }];
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-skeleton-loader .v-skeleton-loader__image {
  width: 100%;
  height: 100% !important;
}
</style>
